// Lucide icon: chart-no-axes-combined (https://lucide.dev/icons/chart-no-axes-combined)
import { ChartNoAxesCombined } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconInsights = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ChartNoAxesCombined />
    </IconComponentStyled>
  )
}
